import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"position":"relative","width":"98%","height":"100%"} }
const _hoisted_2 = {
  class: "pdf-pop-link",
  style: {"display":"block"}
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  style: {"width":"400px","max-width":"90%","position":"absolute","right":"20px","bottom":"0","z-index":"99999","background":"white"}
}
const _hoisted_6 = {
  key: 0,
  style: {"padding":"5px"}
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"display":"flex","padding":"5px 10px"} }
const _hoisted_10 = {
  key: 1,
  style: {"position":"absolute","right":"20px","bottom":"0","z-index":"99999","display":"flex","padding":"5px 10px"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  style: {"width":"400px","max-width":"90%","position":"absolute","right":"20px","bottom":"0","z-index":"99999","background":"white"}
}
const _hoisted_13 = { style: {"max-height":"80vh","overflow":"auto","position":"relative"} }
const _hoisted_14 = {
  key: 0,
  style: {"padding":"5px"}
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { style: {"height":"100px","border-bottom":"1px solid black","margin":"0 10px 10px"} }
const _hoisted_17 = { style: {"padding":"0 10px 10px"} }
const _hoisted_18 = { style: {"display":"flex","padding":"5px 10px"} }
const _hoisted_19 = {
  key: 1,
  style: {"position":"absolute","right":"20px","bottom":"0","z-index":"99999","display":"flex","padding":"5px 10px"}
}
const _hoisted_20 = { style: {"width":"100%","height":"100%"} }
const _hoisted_21 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSignaturePad = _resolveComponent("VueSignaturePad")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.show ? 'error-msg-wrap' : 'hide'),
    style: {"width":"100%"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          href: _ctx.link,
          target: "_blank"
        }, "Open in new tab", 8, _hoisted_3)
      ]),
      (_openBlock(), _createElementBlock("svg", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close())),
        class: "remove-filter",
        style: {"background":"black","border-radius":"50%","width":"auto","fill":"white","top":"-5px","right":"-5px","height":"32px"},
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.094l-4.157-4.104 4.1-4.141-1.849-1.849-4.105 4.159-4.156-4.102-1.833 1.834 4.161 4.12-4.104 4.157 1.834 1.832 4.118-4.159 4.143 4.102 1.848-1.849z" }, null, -1)
      ]))])),
      (_ctx.alreadySigned)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.showSign)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.agreeText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", {
                          innerHTML: _ctx.agreeText,
                          style: {"padding":"10px","border":"1px solid black","border-radius":"5px"}
                        }, null, 8, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: _ctx.thisUserSignOffs[_ctx.step.id].signatureData
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "btn",
                      onClick: _cache[1] || (_cache[1] = () => { _ctx.showSign = false })
                    }, "Hide")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[2] || (_cache[2] = () => { _ctx.showSign = true })
                  }, "View Signature")
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_ctx.showSign)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.agreeText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("div", {
                            innerHTML: _ctx.agreeText,
                            style: {"padding":"10px","border":"1px solid black","border-radius":"5px"}
                          }, null, 8, _hoisted_15)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_VueSignaturePad, { ref: 'signaturePad' })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[8] || (_cache[8] = _createElementVNode("b", null, "Sign Name Above", -1)),
                      _cache[9] || (_cache[9] = _createTextVNode(" - ", -1)),
                      _createElementVNode("a", {
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => { (_ctx.$refs as any).signaturePad.clearSignature() }, ["prevent"]))
                      }, "Clear")
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: "btn",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveSignature && _ctx.saveSignature(...args))),
                        style: {"margin-right":"10px"}
                      }, "Submit"),
                      _createElementVNode("div", {
                        class: "btn",
                        onClick: _cache[5] || (_cache[5] = () => { _ctx.showSign = false })
                      }, "Hide")
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: _cache[6] || (_cache[6] = () => { _ctx.showSign = true })
                  }, "Sign")
                ]))
          ])),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("iframe", {
          style: {"width":"100%","height":"100%"},
          src: _ctx.link
        }, null, 8, _hoisted_21)
      ])
    ])
  ], 2))
}